import { Box, Group } from '@mantine/core';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'src/components/Icon';
import { links } from 'src/router/routes';

import styles from './styles.module.css';

type ThemeOption = {
  id: string;
  image: string;
  label: string;
};

type Props = {
  dictionaryId: number;
  options: ThemeOption[];
};

export const ThemeGrid: FC<Props> = ({ dictionaryId, options }) => {
  return (
    <Box>
      <Group gap="md" align="flex-start">
        <Link
          to={`${links.themeNew}/${dictionaryId}`}
          className={styles.addThemeButton}
        >
          <div>
            <Icon name="add" />
          </div>
        </Link>
        {options.map((theme) => (
          <Link
            key={theme.id}
            to={`${links.theme}/${theme.id}`}
            className={styles.themeLink}
          >
            <img
              src={theme.image}
              alt={theme.label}
              className={styles.themeImage}
            />
            <span className={styles.themeLabel}>{theme.label}</span>
          </Link>
        ))}
      </Group>
    </Box>
  );
};
